import { useEffect, useState } from 'react';
import Button from '@components/Buttons';
import Tabs from '@components/DesignLibrary/Tabs';
import classNames from 'classnames';
import Spacer from '@/components/Spacer';

import { View } from '../types';
import SignInWithPhone from './SignInWithPhone';
import SignInWithEmail from './SignInWithEmail';
import TermsAndPolicy from '../TermsAndPolicy';
import authStyles from '../Auth.module.scss';

type Props = {
  creatorSlug?: string;
  onChangeView: (view: View, data?: { email: string }) => void;
  initialAuthMethod?: 'email' | 'phone';
  isPhoneLoginEnabled: boolean;
  isEmailLoginEnabled: boolean;
  phoneNumber?: string;
  email?: string;
  isCreator?: boolean;
  hasFinishedOnboarding?: boolean;
  isCreatorView?: boolean;
};

const SignInForm: React.FC<Props> = ({
  creatorSlug,
  initialAuthMethod = 'email',
  onChangeView,
  isPhoneLoginEnabled: isPhoneLoginEnabledInput,
  isEmailLoginEnabled: isEmailLoginEnabledInput,
  phoneNumber,
  email,
  isCreator,
  hasFinishedOnboarding,
  isCreatorView,
}) => {
  const [isEmailAuth, setIsEmailAuth] = useState<boolean>(initialAuthMethod === 'email');

  const isPhoneLoginEnabled = isPhoneLoginEnabledInput || initialAuthMethod === 'phone';
  const isEmailLoginEnabled = isEmailLoginEnabledInput || initialAuthMethod === 'email';

  useEffect(() => {
    if (isPhoneLoginEnabled && !isEmailLoginEnabled) {
      setIsEmailAuth(false);
    } else if (!isPhoneLoginEnabled && isEmailLoginEnabled) {
      setIsEmailAuth(true);
    } else if (isPhoneLoginEnabled && isEmailLoginEnabled) {
      setIsEmailAuth(initialAuthMethod !== 'phone');
    } else {
      setIsEmailAuth(true);
    }
  }, [initialAuthMethod, isPhoneLoginEnabled, isEmailLoginEnabled]);

  const handleTapSignUp = (): void => onChangeView('signUp');

  return (
    <fieldset
      className={classNames(authStyles.formwrapper, {
        [authStyles.creatorFormWrapper]: isCreatorView,
      })}
    >
      <legend>Sign In</legend>
      <div className={authStyles.signInForm}>
        {isEmailLoginEnabled && isPhoneLoginEnabled && (
          <>
            <Tabs
              inputName="authType"
              inputs={[
                { id: 'auth-email', label: 'Email' },
                { id: 'auth-phone', label: 'Phone' },
              ]}
              onChange={val => setIsEmailAuth(val === 'auth-email')}
            />
            <Spacer />
          </>
        )}
        {isEmailAuth
          ? (
            <SignInWithEmail
              onChangeView={onChangeView}
              creatorSlug={creatorSlug}
              email={email}
              isCreator={isCreator}
              hasFinishedOnboarding={hasFinishedOnboarding}
            />
          )
          : (
            <SignInWithPhone
              onChangeView={onChangeView}
              creatorSlug={creatorSlug}
              phoneNumber={phoneNumber}
              isCreator={isCreator}
              hasFinishedOnboarding={hasFinishedOnboarding}
            />
          )}
      </div>
      <TermsAndPolicy isSignIn isCreatorView={isCreatorView} />
      <small>
        Don&apos;t have an account?{' '}
        <Button
          isWrapper
          onClick={handleTapSignUp}
          className={classNames({
            [authStyles.creatorSignupButton]: isCreatorView,
          })}
        >
          Sign up
        </Button>
        .
      </small>
    </fieldset>
  );
};

export default SignInForm;
